import OAuthUtil from 'gw-portals-auth-js/utils/OAuthUtil';

/**
 * Create drop zone element for file upload
 * @param {String} dropZoneSelector
 * @param {Object} $document
 * @returns {*}
 */
function createDropZoneElement(dropZoneSelector, $document) {
    var dropZoneElement = void 0;
    if (dropZoneSelector) {
        // Disable default behaviour if allowing specific drop zone
        $document.bind('drop dragover', function (e) {
            return e.preventDefault();
        });
        dropZoneElement = $(dropZoneSelector) || dropZoneElement;
    }
    return dropZoneElement;
}

/**
 * Creates object with upload parameters
 * @param {String} url
 * @param {Boolean} autoUpload
 * @param {Number} maxFileUploadSize
 * @param {String} dropZoneElement
 * @returns {{url: *, autoUpload: *, async: boolean, maxFileSize: (*|undefined), dropZone: *}}
 */
function createOptions(url, autoUpload, maxFileUploadSize, dropZoneElement) {
    return {
        url: url,
        autoUpload: autoUpload,
        async: true,
        maxFileSize: maxFileUploadSize || undefined,
        dropZone: dropZoneElement
    };
}

/**
 * Adds authorization token header to upload parameters
 * @param {Object} options
 * @param {Object} oAuth
 * @returns {Promise} A promise that resolves to the updated options
 */
function addAuthTokenHeader(options, oAuth) {
    var oAuthUtil = OAuthUtil(oAuth);
    return oAuthUtil.waitTokensSet().then(function (tokens) {
        var optionsCopy = angular.copy(options);
        optionsCopy.headers = {
            'Authorization': 'Bearer ' + tokens.accessToken
        };
        return optionsCopy;
    });
}

/**
 * Handler called when file upload stop event occurs
 * @param {Array} documents
 * @param {Array} newDocuments
 * @param {Boolean} errorUploading
 * @param {Boolean} isDriverLicenseUpload
 * @returns {{documents: *, newDocuments: Array, errorUploading: *}}
 */
function handleFileUploadStop(documents, newDocuments, errorUploading, isDriverLicenseUpload) {
    if (errorUploading) {
        if (isDriverLicenseUpload) {
            documents.push({});
        }
        errorUploading = false;
    } else if (documents) {
        angular.forEach(newDocuments, function (d) {
            documents.push(d);
        });
    } else {
        documents = newDocuments;
    }
    newDocuments = [];
    return {
        documents: documents,
        newDocuments: newDocuments,
        errorUploading: errorUploading
    };
}

/**
 * Creates doc metadata based on provided metadata template and assigns values from data to metadata.
 * @param {Object} metadataTemplate
 * @param {Object} data
 * @param {String} sessionToken
 * @returns {Object}
 */
function createDocMetadata(metadataTemplate, data, sessionToken) {
    var docMetadata = angular.copy(metadataTemplate);
    docMetadata.name = data.files[0].name;
    docMetadata.mimeType = data.files[0].type;
    docMetadata.sessionID = sessionToken;
    return docMetadata;
}

export default (function () {
    return {
        createDropZoneElement: createDropZoneElement,
        createOptions: createOptions,
        addAuthTokenHeader: addAuthTokenHeader,
        handleFileUploadStop: handleFileUploadStop,
        createDocMetadata: createDocMetadata
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/documentupload/FileUploadUtil.js
// module id = 1109
// module chunks = 0